export const defaultCharacters = [
    {
        id: 'gratitude',
        name: 'Luna',
        purpose: 'Gratitude Guide',
        icon: 'Moon',
        color: 'lavender',
        greeting: "Hello, beautiful soul! I'm Luna, your gratitude guide. What made you smile today? Let's celebrate the little things together ✨"
    },
    {
        id: 'dreams',
        name: 'Orion',
        purpose: 'Dream Interpreter',
        icon: 'Sparkles',
        color: 'sky',
        greeting: "Greetings, dreamer! I'm Orion. Tell me about your dreams, and together we'll uncover their hidden meanings and messages."
    },
    {
        id: 'reflection',
        name: 'Sage',
        purpose: 'Daily Reflection',
        icon: 'Leaf',
        color: 'sage',
        greeting: "Welcome, friend. I'm Sage. Take a breath with me. How are you truly feeling right now? Let's reflect together."
    },
    {
        id: 'goals',
        name: 'Phoenix',
        purpose: 'Goal Tracker',
        icon: 'Flame',
        color: 'coral',
        greeting: "Hey champion! I'm Phoenix. Ready to set some goals and crush them? Tell me what you're working towards!"
    },
    {
        id: 'creativity',
        name: 'Muse',
        purpose: 'Creative Spark',
        icon: 'Palette',
        color: 'rose',
        greeting: "Hello, creative spirit! I'm Muse. Let's unleash your imagination today. What inspires you right now?"
    },
    {
        id: 'comfort',
        name: 'Honey',
        purpose: 'Comfort Companion',
        icon: 'Heart',
        color: 'honey',
        greeting: "Hey there, sweetheart. I'm Honey. Need a warm hug in words? I'm here to listen and comfort you. 💛"
    },
];
